import {Exclude, Expose, Type} from 'class-transformer';
import {AbstractApiModel} from './abstract.api.model';
import {SupportRequestCategoryEnum} from '../../core/enums/support-request-category.enum';
import {SupportRequestAttachmentApiModel} from './support-request-attachment.api-model';
import {UserApiModel} from './user.api-model';

@Exclude()
export class SupportRequestApiModel extends AbstractApiModel {
  @Expose() public category: SupportRequestCategoryEnum;
  @Expose() public contactEmail: string;
  @Expose() public topic: string;
  @Expose() public content: string;
  @Expose() @Type(() => SupportRequestAttachmentApiModel) public attachments: (SupportRequestAttachmentApiModel | string)[] = [];
  @Expose() @Type(() => UserApiModel) public reportedBy: UserApiModel | string;
  @Expose() public reportedByName: string | null;
  @Expose() public archivedAt: string | null;
  @Expose() public createdAt: Date;
  @Expose() public updatedAt: Date;
}
